import { useState as f, useCallback as E, useEffect as L } from "react";
const d = 2;
function v(s) {
  const [a, c] = f("none"), e = E(() => {
    const t = s.current;
    if (!t) {
      c("none");
      return;
    }
    const n = document.documentElement.dir === "rtl", r = t.scrollLeft, o = t.clientWidth, l = t.scrollWidth, u = n ? r - d > o - l : r > 0, b = l - o, i = n ? r < 0 : r + d < b;
    c(u && i ? "both" : u ? "left" : i ? "right" : "none");
  }, [s.current]);
  return L(() => {
    const t = s.current;
    if (!t)
      return;
    e();
    const n = new ResizeObserver(e);
    return n.observe(t), t.addEventListener("scroll", e), () => {
      t.removeEventListener("scroll", e), n.disconnect();
    };
  }, [e]), a;
}
export {
  v as useScrollBlur
};
